import { motion } from "framer-motion";
import { Star, BadgeCheck } from "lucide-react";

const reviews = [
  {
    testid: "testimonial-card-1",
    quote: "Lauren got our fridge and oven looking brand new before our move-out inspection. Full deposit back — worth every penny.",
    name: "Megan R.",
    where: "Fayetteville, AR",
  },
  {
    testid: "testimonial-card-2",
    quote: "I've tried three cleaning services in NWA. Tidy Tusks is the only one that noticed the baseboards, the vents, everything. Bi-weekly for a year now.",
    name: "Daniel & Priya K.",
    where: "Bentonville, AR",
  },
  {
    testid: "testimonial-card-3",
    quote: "Two kids, one dog, zero time. Lauren leaves the house fresh and spotless every single visit — she's the real deal.",
    name: "Ashley T.",
    where: "Rogers, AR",
  },
];

const Testimonials = () => (
  <section id="reviews" className="py-20 md:py-28 bg-[#1A1A1A] text-white">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="max-w-2xl mb-12 md:mb-16">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#D4AF37] mb-3">Verified reviews</p>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-snug">
          Neighbors who <span className="italic text-[#E8B4B8]">squeal</span> about their clean
        </h2>
      </div>
      <div className="grid md:grid-cols-3 gap-5 md:gap-6">
        {reviews.map((r, i) => (
          <motion.figure
            key={r.name}
            data-testid={r.testid}
            initial={{ opacity: 0, y: 26 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ delay: i * 0.1, duration: 0.55 }}
            className="bg-[#2D2D2D] border border-white/10 rounded-3xl p-7 flex flex-col hover:border-[#990000]/60 transition-colors duration-300"
          >
            <div className="flex gap-1 mb-4">
              {[...Array(5)].map((_, j) => (
                <Star key={j} size={15} className="fill-[#D4AF37] text-[#D4AF37]" />
              ))}
            </div>
            <blockquote className="text-sm md:text-base text-white/85 leading-relaxed flex-1">"{r.quote}"</blockquote>
            <figcaption className="mt-6 flex items-center gap-2.5">
              <div>
                <div className="font-semibold text-sm flex items-center gap-1.5">{r.name} <BadgeCheck size={14} className="text-[#D4AF37]" /></div>
                <div className="text-xs text-white/55 mt-0.5">{r.where}</div>
              </div>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);

export default Testimonials;
